import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import { isAllOrEmpty } from './builders.utils';

/**
 * Variety is shared across models with different feature shapes, so each call site supplies how the
 * variety name is read (disease-risk: `p.values?.variety_name`; mycotoxin: `p.variety`).
 */
export const buildVarietyFilter = <P>(getVariety: (properties: P) => string | undefined): Filter =>
  buildFilter<P>({
    type: RegionalOverviewFilterType.VARIETY,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    getValues: feature => {
      const variety = feature.properties ? getVariety(feature.properties) : undefined;
      return variety ? [variety] : [];
    },
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const variety = feature.properties ? getVariety(feature.properties) : undefined;
      if (!variety) return false;
      return (value as string[]).includes(variety);
    }
  });
